import React from 'react';
import IdeaStep from './IdeaStep';
import PriorityStep from './PriorityStep';
import PlanStep from './PlanStep';
import BuildStep from './BuildStep';
import Schedule from '../Schedule/index';
import ResultsStep from './ResultsStep';
import StepNotReached from './StepNotReached';
import { hasReachedStep, testId } from '../epmHelpers';

const stepPrompts = [
    ['Idea title', 'What customer or business problem are you solving?'],
    ['ICE score', 'Why should this idea be prioritised now?'],
    ['Hypothesis', 'Primary success metric'],
    ['Experience owner', 'QA checklist or acceptance criteria'],
    ['Preferred launch date', 'Funnel lane'],
    ['Outcome', 'What did the programme learn?'],
];

const WorkflowStep = ({ step, stepIndex, testData, setTestData, learningFlushRef }) => {
    if (stepIndex === 0) return <IdeaStep testData={testData} setTestData={setTestData} />;
    if (stepIndex === 1) return <PriorityStep testData={testData} setTestData={setTestData} />;
    if (stepIndex === 2) return <PlanStep testData={testData} setTestData={setTestData} />;
    // Later steps show a placeholder until the test reaches them.
    if (stepIndex >= 3 && !hasReachedStep(testData, stepIndex)) {
        return <StepNotReached stepIndex={stepIndex} testData={testData} />;
    }
    // Keyed by test so the step's local state starts again from the test's own data
    const key = String(testId(testData));
    if (stepIndex === 3) return <BuildStep key={key} testData={testData} setTestData={setTestData} />;
    if (stepIndex === 4) return <Schedule isStep testData={testData} setTestData={setTestData} />;
    if (stepIndex === 5) return <ResultsStep key={key} testData={testData} setTestData={setTestData} learningFlushRef={learningFlushRef} />;

    return (
    <div className="epm-workflow-step">
        <div className="epm-workflow-step__heading">
            <span>{String(stepIndex + 1).padStart(2, '0')}</span>
            <div><h2>{step.label}</h2><p>{step.description}</p></div>
        </div>
        <div className="epm-workflow-step__fields">
            {stepPrompts[stepIndex].map((prompt, index) => (
                <label key={prompt} className={index === 1 ? 'epm-workflow-step__field epm-workflow-step__field--large' : 'epm-workflow-step__field'}>
                    <span>{prompt}</span>
                    {index === 1
                        ? <textarea rows="5" placeholder={`Enter ${prompt.toLowerCase()}`} />
                        : <input type={stepIndex === 4 && index === 0 ? 'date' : 'text'} placeholder={`Enter ${prompt.toLowerCase()}`} />}
                </label>
            ))}
        </div>
    </div>
    );
};

export default WorkflowStep;
